import normalizeText from '@/lib/normalizeText.js';

const toTimestampMs = (value) => {
  const normalizedValue = normalizeText(value);

  if (!normalizedValue) {
    return null;
  }

  const parsed = Date.parse(normalizedValue);

  if (!Number.isFinite(parsed)) {
    return null;
  }

  return parsed;
};

const toTimeAgo = (value) => {
  const timestampMs = toTimestampMs(value);

  if (!Number.isFinite(timestampMs)) {
    return '';
  }

  const deltaSeconds = Math.max(0, Math.floor((Date.now() - timestampMs) / 1000));

  if (deltaSeconds < 60) {
    return `${deltaSeconds}s`;
  }

  const deltaMinutes = Math.floor(deltaSeconds / 60);

  if (deltaMinutes < 60) {
    return `${deltaMinutes}m`;
  }

  const deltaHours = Math.floor(deltaMinutes / 60);

  if (deltaHours < 24) {
    return `${deltaHours}h`;
  }

  const deltaDays = Math.floor(deltaHours / 24);
  return `${deltaDays}d`;
};

export { toTimestampMs, toTimeAgo };
